import React, { useEffect, useState } from "react";
import Accordions from "../../components/Acoordion";
import axios from "axios";
import ApiUrl from "../../config/app-config";

const baseURL = ApiUrl();

const QnaList = (props) => {
  const pageName = "문의내역";
  const users = sessionStorage.getItem("userId");
  const loginToken = sessionStorage.getItem("loginToken");
  const userId = Number(users);
  const headerUi = {
    goback: true,
    closeAll: false,
    Navi: "/qna/write",
  };
  useEffect(() => {
    props.onPageName(pageName);
  }, []);
  useEffect(() => {
    props.onHeaderUi(headerUi);
  }, []);

  /**list 데이터 받아오기 */
  const [data, setData] = useState();

  const getListData = () => {
    props.onIsLoading(true);
    axios({
      url: `${baseURL}/v1/qna/list`,
      method: "post",
      params: {
        currentPageIndex: 1,
        listSize: 50,
      },
      data :{
        "userId" : userId && userId,
      },
      headers:
        { Authorization: loginToken && loginToken },
    })
      .then(function a(response) {
        props.onIsLoading(false);
        const success = response.data;
        const result = success.result;
        props.onIsLoading(false);
        setData(result);
      })
      .catch(function (error) {
        props.onIsLoading(false);
        props.onError(true);
      });
  };

  useEffect(() => {
    if (loginToken || userId) {
      getListData();
    } else if (!loginToken && (!userId || userId == 0)) {
      props.onError(true);
    }
  }, [loginToken]);

  // async function getData() {
  //   props.onIsLoading(true);
  //   try {
  //     //응답 성공
  //     const response = await axios.get(`${baseURL}/v1/qna`, {
  //       params: {
  //         listSize: 50,
  //         currentPageIndex: 1,
  //         userId: userId,
  //       },
  //     });
  //     const success = response.data;
  //     const result = success.result;
  //     props.onIsLoading(false);
  //     setData(result);
  //     //console.log("QNAListdata", result);
  //   } catch (error) {
  //     //응답 실패
  //     props.onIsLoading(false);
  //     props.onError(true);
  //     console.error(error);
  //   }
  // }
  // useEffect(() => {
  //   getData();
  // }, []);

  return (
    <div className="qna_list_wrap" style={{ marginTop: "70px" }}>
      <div className="faq_list_wrap">
        {data && data.length > 0 ? (
          <div className="faq_lists accordion_wrap tabs">
            {data &&
              data.map((item) => {
                return <Accordions key={`accor${item.id}`} qnaList={item} />;
              })}
          </div>
        ) : (
          <div className="no_list">
            <h5>문의 내역이 없습니다.</h5>
          </div>
        )}
      </div>
    </div>
  );
};
export default QnaList;
